import styled from 'styled-components/macro'
import { BREAKPOINTS, COLORS, fadeIn } from '../GlobalStyles'
import { ImageLoader } from '../components/ImageLoader'
import headshot from '../assets/headshot1.png'

export const Story = () => (
  <Wrapper className='story'>
    <div className='inner'>
      <div className='headshot'>
        <ImageLoader src={headshot} alt='Victoria Peart headshot' borderRadius='20px' />
      </div>
      <div className='text'>
        <p className='about'>about</p>
        <h1 className='title'>[ <b>Victoria Peart</b> ]</h1>
        <p>
          I’m a Full Stack Developer based in West Kelowna, BC, with a passion for blending  
          intuitive design, robust UX, and maintainable code. My creative background in art and interest in literature drives me to craft interfaces that look great and feel even better.
        </p>
        <p>
          Since 2021, I’ve been architecting and refining complex dashboards end-to-end. Colleagues affectionately call me the ‘UX Queen’ for my knack for elevating user experiences and mentoring best practices.
        </p>
        <p>
          Outside of work, you’ll find me exploring trails with my partner, curled up with a good book, gaming, or unwinding at home with our two rescue cats. Nature and play keep my creativity and problem-solving sharp.
        </p>
      </div>
    </div>
  </Wrapper>
)

const Wrapper = styled.div`
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  min-height: 100vh;
  display: grid;
  place-content: center;
  .inner {
    animation: ${fadeIn} 1.5s ease-in-out;
    display: grid;
    place-content: center;
    gap: 30px;
    padding: 100px 20px 50px;
  }
  .headshot {
    filter: grayscale(100%);
    width: 100%;
    max-width: 400px;
    border-radius: 20px;
  }
  .text {
    display: flex;
    flex-direction: column;
    font-weight: 300;
    max-width: 600px;
    .about {
      color: ${COLORS.primaryAccent};
      font-size: 1.8rem;
      font-weight: bold;
      margin: 0;
    }
    .title {
      font-size: 2rem;
      margin-bottom: 20px;
    }
    p {
      margin: 10px 0;
      line-height: 1.6;
    }
  }
  @media only screen and (min-width: ${BREAKPOINTS.tablet}) {
    .inner {
      gap: 40px;
    }
  }
  @media only screen and (min-width: ${BREAKPOINTS.desktop}) {
    .inner {
      display: flex;
      align-items: flex-start;
      gap: 50px;
    }
  }
`
